<template lang="pug">
.container-fluid
  //- h1 Returns
  .card.shadow.mb-4
    .card-header.py-3.d-flex.flex-row.align-items-center.justify-content-between
      h2.m-0.font-weight-bold.text-primary Returns          
    .searchResults
    .card-body
      .col-12(style="overflow:auto;")   
        div(style="text-align:center" v-if="loading")
          Spinner(size="medium" message="Loading...")
        transition( name="fade")
          table#tablePreview.table(v-if="!loading")
            thead
              tr                
                th Actions
                th Date
                th Age
                th Tracking No.
                th Carrier
                th Platform
                th Return Address                
            tbody(v-for="(theReturn, index) in returns")
              tr                
                td.text-center.returnSelect
                  select(v-model="theReturn.status" @change="updateReturnStatus(index)")
                    option(value="created") Created
                    option(value="voided") Voided
                    option(value="shipped") Shipped
                    option(value="received") Received
                    option(value="processing") Processing
                    option(value="completed") Completed
                  i.fas.fa-fw.fa-print.pointer(v-on:click="printLabel(theReturn._id)" title="Return Label")
                  i.fas.fa-fw.fa-truck-moving.pointer(v-on:click="trackingStatus(theReturn._id, theReturn.carrier)" title="Tracking Status")
                td {{theReturn.created_at | moment("MM/DD/YYYY") }}
                td {{ today - theReturn.created_at | duration("humanize")}}
                td {{theReturn.trackingNumber}}
                td {{theReturn.carrier}}
                td {{theReturn.channel}}
                td {{theReturn.returnAddress}}
                
      .col-12.text-center( style="display:flex;justify-content:center")
        ul.pagination
          li.page-item.nav-item(title="First Page")
            a.page-link( aria-label='Previous' v-on:click="firstPage()")
              span(aria-hidden='true') «
              span.sr-only Previous
          li.page-item.nav-item
            a.page-link( v-if="page >1" v-on:click="prevPage()") {{page - 1}}
          li.page-item.nav-item
            a.page-link(style="font-weight:bold") {{page}}
          li.page-item.nav-item
            a.page-link( v-if="page < maxPage" v-on:click="nextPage()") {{page + 1}}
          li.page-item.nav-item(v-bind:title="`Last Page: ${maxPage}`")
            a.page-link(aria-label='Next')
              span(aria-hidden='true' v-on:click="lastPage()") »
              span.sr-only Next
      transition( name="fade")
        .orderFormWrap(v-if="printLabelModal")
          .orderContainer
            .ordergogo()
              ReturnLabel(
                :returnLabelInfo="returnLabelInfo"
                @closeModal="closeModal"
              )
          .orderFormBg(v-on:click="closeModal")
      transition( name="fade")
        .orderFormWrap(v-if="trackingStatusModal")
          .orderContainer
            .ordergogo()
              TrackingStatus(
                :returnLabelInfo="returnLabelInfo"
                :returnLabelCarrier="returnLabelCarrier"
                @closeModal="closeModal"
              )
          .orderFormBg(v-on:click="closeModal")


</template>

<script>
import ReturnLabel from '@/components/ReturnLabel'
import TrackingStatus from '@/components/TrackingStatus'
import Spinner from 'vue-simple-spinner'
export default {
  name: 'Returns',
  components:{
    ReturnLabel,
    Spinner,
    TrackingStatus
  },
  props: {
    returnLabelId:String,
  },
  metaInfo: {
    title: 'Returns',
  },
  data:function(){
    return{
      today: new Date(),
      page: 1,
      maxPage:1,
      limit:25,
      offset:0,
      returns:null,
      printLabelModal:false,
      trackingStatusModal:false,
      returnLabelInfo:null,
      returnLabelCarrier:null,
      loading:true,
    }
  },
  methods:{
    async printLabel(id){
      this.returnLabelInfo = id;
      this.printLabelModal = true;
    },
    async updateReturnStatus(index){
      this.flash('Updating return status...', 'warning')
      var bodyFormData = new FormData();
      bodyFormData.append(`returnId`, this.returns[index]._id)
      bodyFormData.append(`status`, this.returns[index].status)
      var response = await this.axios.post(`/rp/server/returns/update`, bodyFormData)
      if(response.data.error) this.flash(response.data.error.message, 'error')
      else{ 
        this.flash('Return updated', 'success')
      }
    },
    async trackingStatus(id,carrier){
      // alert('hi')
      this.returnLabelInfo = id;
      this.returnLabelCarrier = carrier.toLowerCase();
      this.trackingStatusModal = true;
    },
    nextPage(){
      this.page ++
      this.init();
    },
    prevPage(){
      this.page --
      this.init();
    },
    firstPage(){
      this.page = 1
      this.init();
    },
    lastPage(){
      this.page = this.maxPage;
      this.init()
    },    
    closeModal(){
      this.printLabelModal = false;
      this.trackingStatusModal = false;
      this.returnLabelInfo = null;
      this.returnLabelCarrier = null;
    },
  },
  async mounted(){
    // 5f06de32e4b0c888873b69ae
    if(this.returnLabelId){
      this.printLabelModal = true;
      this.returnLabelInfo = this.returnLabelId;
    }
    var returns = await this.axios.get(`/rp/server/returns/?limit=${this.limit}&offset=${this.offset}`)
    this.returns = returns.data    
    this.loading = false;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .returnSelect{
    width:230px;
    display:flex;
    justify-content: center;
    align-items: center;
    select{
      margin-right:15px; 
    }
    i{
      margin-right:5px;
    }
  }
 .orderFormWrap{
    position:fixed;
    display:flex;
    justify-content: center;
    align-items: center;
    width:100vw;
    height:100vh;
    top:0;
    left:0;
    .orderContainer{
      max-width:80vw;
      max-height:800px;
      padding:10px 0px;
      background:white;
      border-radius: 10px;      
      box-shadow: 0px 0px 10px 1px rgba(0,0,0,.5);
      z-index: 9;
      .ordergogo{
        width:65vw;
        // padding:20px;
        height:80vh;
        overflow:auto;
        border-radius: 5px;
      }
    }
    .orderFormBg{
      width:100%;
      height:100%;
      z-index: -1;
      position: absolute;
      top:0;
      background:rgba(0,0,0,.2);
    }

  }
</style>
